import { getMfaState, verifyTotp } from "@/features/auth/api/mfa";
import { mfaSearchSchema } from "@/features/auth/search/mfaSearch";
import { useLogoutMutation } from "@/features/auth/api/useLogoutMutation";
import { MfaChallengeScreen } from "@/features/auth/screens/MfaChallengeScreen";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { authQueryOptions } from "@/features/auth/api/useAuthQuery";

function MfaChallengePage() {
    const { returnTo } = Route.useSearch();
    const navigate = useNavigate();
    const logout = useLogoutMutation();
    const [factorId, setFactorId] = useState("");
    const [pending, setPending] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        void getMfaState()
            .then((state) => {
                if (state.currentLevel === "aal2") window.location.assign(returnTo);
                else if (state.verifiedTotp[0]) setFactorId(state.verifiedTotp[0].id);
                else void navigate({ to: "/mfa/enroll", search: { returnTo }, replace: true });
            })
            .catch((cause: unknown) => setError(cause instanceof Error ? cause.message : "Could not load MFA."));
    }, [navigate, returnTo]);

    const verify = async (code: string) => {
        setPending(true);
        setError("");
        try {
            await verifyTotp(factorId, code);
            window.location.assign(returnTo);
        } catch (cause) {
            setError(cause instanceof Error ? cause.message : "The code could not be verified.");
            setPending(false);
        }
    };

    return (
        <MfaChallengeScreen
            factorReady={Boolean(factorId)}
            pending={pending}
            error={error}
            onVerify={(code) => void verify(code)}
            onLogout={() => logout.mutate()}
        />
    );
}

export const Route = createFileRoute("/_auth/mfa/challenge")({
    component: MfaChallengePage,
    validateSearch: (search) => mfaSearchSchema.parse(search ?? {}),
    beforeLoad: async ({ context }) => {
        if (!(await context.queryClient.ensureQueryData(authQueryOptions()))) throw redirect({ to: "/login" });
    },
});
